import Image from "next/image";
import Link from "next/link";
import ReactTimeAgo from "react-time-ago";
import styled from "styled-components";

const EventCards = (props) => {
	if (props.options && props.options.image) {
		return (
			<div className="each_card grid">
				<Link href={`/${props.username}/events/${props.options.slug}`}>
					<Image
						unoptimized
						src={props.options.image?.split("?")[0]}
						alt={props.options.title}
						width={318}
						height={150}
					/>
				</Link>
				<span className="price">
					{props.options.price === null ? "Free" : `N ${props.options.price}`}
				</span>
				<div className="event_details">
					<h4>
						<ReactTimeAgo date={props.options.start_date} />
						{props.start_date}
					</h4>

					<div>
						<Link
							href={`/${props.username}/events/${props.options.slug}`}
							className="heading_details"
						>
							<h3>{props.options.title}</h3>
						</Link>
						<p>{props.options.description.slice(0, 200)}</p>
						<ReactMetaLink>
							<p>
								<span class="material-symbols-outlined">apartment</span>
								{props.options.company.name}
							</p>
							{props.adminNav ? (
								<p>
									<Link
										href={`/${props.username}/events/${props.options.slug}/manage`}
									>
										<span class="material-symbols-outlined">group</span> Manage
									</Link>
								</p>
							) : (
								""
							)}
						</ReactMetaLink>
					</div>
				</div>
			</div>
		);
	}
};

export default EventCards;

const ReactMetaLink = styled.div`
	display: flex;
	justify-content: space-between;
	span {
		position: relative;
		top: 5px;
	}
`;
